<div class="mem-picker" *ngIf="options.length; else emptyMembers">
    <label class="mem-opt" *ngFor="let opt of options; trackBy: trackById" [attr.data-member]="opt.id" [attr.aria-disabled]="opt.locked ? 'true' : null"
           [style.cursor]="opt.locked ? 'default' : null" (click)="toggle(opt.id); $event.preventDefault()">
        <span class="checkbox" [class.checked]="isChecked(opt.id)">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                <path d="M20 6L9 17l-5-5"/>
            </svg>
        </span>
        <div class="avatar avatar-sm" [ngClass]="avatarClass(opt)">{{ deriveInitials(opt) }}</div>
        <div>
            <div class="mem-name">{{ opt.name }}</div>
            <div class="mem-meta" *ngIf="opt.meta">{{ opt.meta }}</div>
        </div>
    </label>
</div>
<ng-template #emptyMembers>
    <div class="field-hint">{{ emptyHint }}</div>
</ng-template>
